export const darkGradientSx = {
  backgroundColor: '#05070a',
  backgroundImage:
    'radial-gradient(circle at 20% 20%, rgba(96, 165, 250, 0.16), transparent 55%), radial-gradient(circle at 80% 60%, rgba(167, 139, 250, 0.14), transparent 55%)',
};
